module.exports = __webpack_public_path__ + "components/page-header/static/icon-heart-fill-80529196ab09b8a9a98815f2bbea1a2b.svg";